module.exports = __webpack_public_path__ + "static/media/993903.05d0d0c2.png";